export const GRADUATION_DATA = {
  fallback: {
    achievements: [
      'Worked out for over 6 hours',
      'Prepared over 80 nutritious meals',
    ],
    hashtag: '#voomeprograms',
  },
  kickstarter: {
    achievements: [
      'Squatted 300 times',
      'Planked for 10 minutes',
      'Wall sat for 10 minutes',
      'Walked over 15kms',
    ],
    hashtag: '#voomekickstarter',
  },
  kickstarter2: {
    achievements: [
      'Over 2.5 hours of walking and jogging',
      'Over 330 Squats, including squats with lunges',
      '300 Push Ups using 5 unique styles',
      'Over 2 hours spent rolling and releasing knots',
      'PLUS an additional 40 minutes of stretching!',
    ],
    hashtag: '#voomekickstarter2',
  },
  energyPerformance: {
    achievements: [
      'Squatted & Lunged for over 30 mins',
      'Crunched over 1 hour of abs',
      'Over 14 minutes of push ups',
      'Smashed over 20 minutes of cardio',
    ],
    hashtag: '#voomeenergy',
  },
  timesaver: {
    achievements: [
      'Planked for over 10 minutes',
      'Smashed up to 100 burpees',
      'Lunged over 130 times',
      'Up to 500 squats done & dusted',
    ],
    hashtag: '#voometimesaver',
  },
  barbellProgressions: {
    achievements: [
      'Lunged over 150 lunges',
      'Killed over 229 deadlifts',
      'Smashed over 222 squats',
      'Powered through 84 overhead presses',
    ],
    hashtag: '#voomebarbellprogressions',
  },
  easeFlow: {
    achievements: [
      'Lengthened your spine',
      'Worked through 75 Downward dogs',
      'Relaxed your mind',
      'Held 55 Planks',
      'Stretched every muscle',
    ],
    hashtag: '#voomeeaseflow',
  },
  stabiliseCoreGlutes: {
    achievements: [
      'Mastered 9 different animal poses',
      'Rocked a plank 215 times',
      'Smashed 350 squats in 7 variation',
      'Built a titanium-strength core',
    ],
    hashtag: '#voomestabilise',
  },
  lowFodmap: {
    achievements: [
      'Conquered Meatless Mondays for 1 month',
      'Blitzed up to 24 cups of lactose free milk',
      'Cracked, scrambled & baked approx 3 dozen eggs',
      'Pumped along your digestive system with 62 push ups',
      'Smashed through 3 varieties of 46 dips',
      'Walked, hill climbed & jogged for 2.5 hours',
    ],
    hashtag: '#voomeFODMAP',
  },
  lowImpactWeightloss: {
    achievements: [
      'Smashed 600 squats, 10 different ways',
      'Conquered a mountain with 400 mountain climbers',
      'Toned your abs with 185 planks',
      'Became a burpee champion with over 600 burpees',
      'Pushed your way through over 500 push ups',
    ],
    hashtag: '#voomelowimpact',
  },
  athleticConditioning: {
    achievements: [
      'Squatted the equivalent of a small car',
      'Deadlifted the equivalent of a small tank',
      'Mastered 10 CrossFit moves and 3 Olympic Lifts',
      'Dominated 8 Different Styles of Squats',
      'Smashed 3 hours of high intensity conditioning',
    ],
    hashtag: '#voomeathletic',
  },
  fireUp: {
    achievements: [
      'Burnt over 10,000 calories',
      'Created amazing shoulder mobility',
      'Rocket boosted your metabolism to an ultimate fat-burning zone',
      'Smashed out over 200 squats',
      'Mastered 8 Athletic moves with Dumbbells',
    ],
    hashtag: '#voomefireup',
  },
  '50FitFiring': {
    achievements: [
      'Punched and twisted over 160 reps',
      'Lengthened and untwisted your body with over 20 different stretches',
      'Mastered an entire workout using a Swiss Ball',
      'Experienced just how good the human body can feel',
    ],
    hashtag: '#voome50fitfiring',
  },
  healthyOnABudget: {
    achievements: [
      'Made meals for $15 per day per person',
      "Smashed over 2 hours of AMRAP's",
      'Shopped smarter, meal prepped and batch cooked',
      'Sculpted your legs with 100’s of lunges',
      'Learnt money saving healthy hacks and tips',
    ],
    hashtag: '#voomehealthybudget',
  },
  healthyFamilies: {
    achievements: [
      'You enhanced your gut microbiome',
      'Clocked up 6 hours of walking and/or jogging',
      'You consumed plenty of superb antioxidants',
      'Smashed over 2 hours of escalating circuts',
      'Baked, sliced, rolled and blitzed nourishing snacks',
      'Completed over 3 hours of awesome AMRAP’s',
    ],
    hashtag: '#voomehealthyfamilies',
  },
  powerThroughPregnancy: {
    achievements: [
      'Activated your Pelvic Floor over 150 times',
      'Stabilised and strengthened your lower back',
      'Kept your posture strong',
      'Worked through over 3 hours of cardio',
      'Nurtured yourself and your baby',
    ],
    hashtag: '#voomepregnancy',
  },
};

export const SPECIAL_REQUIREMENT_PRODUCTS = [
  'healthy-on-a-budget',
  'power-through-pregnancy',
];



// WEBPACK FOOTER //
// ./src/constants/Product.js